import { EntityInterface } from 'app/core/entity.model';

import { ErrorInterface } from './error.model';

export interface ErrorEntityInterface extends EntityInterface<ErrorInterface, string> { }

export class ErrorEntity implements ErrorEntityInterface {
  public readonly id: string;

  constructor(public readonly entity: ErrorInterface, id?: string) {
    // TODO: generate actual unique id here if one isn't specified
    this.id = id || (this.entity.timestamp || Date.now()).toString();
  }
}
